import { Typography } from "@mui/material";
import React from "react";
import AllExamAndExercises from "../../components/allExamAndExercises";

const initialHeadCells = [
  {
    id: "title",
    numeric: false,
    label: "الاسم",
  },
  {
    id: "academicYear",
    numeric: false,
    label: "المرحلة الدراسية",
  },
  {
    id: "price",
    numeric: true,
    label: "السعر",
  },
];

function Exercises({ authority }) {
  return (
    <div>
      <Typography
        style={{ fontSize: "30px", color: "#010004", textAlign: "center" }}
      >
        التمارين
      </Typography>
      <AllExamAndExercises
        authority={authority}
        addToUser={false}
        type = "exercises"
        api={"/exercises/admin/getMany"}
        initialHeadCells={initialHeadCells}
        path={"/exercise/"}
        title="اضافة تمرين"
      />
    </div>
  );
}

export default Exercises;
